var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.957 11.018c.286.3.761.31 1.06.024l4.81-4.59a.25.25 0 0 1 .346 0l4.81 4.59a.75.75 0 0 0 1.035-1.085l-4.81-4.59a1.75 1.75 0 0 0-2.416 0l-4.81 4.59a.75.75 0 0 0-.025 1.06",
    clipRule: "evenodd"
  })));
};
export default SvgChevronUp;